import { FormControl } from 'baseui/form-control'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import ElectricCarDistance from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/ElectricCarDistance'

const EquipmentFields = () => {
  const { t, energyLandscape, heatingEnergy, updateAddressEnergyLandscape } = useAddress()

  const { dishwasher, dryer, freezer, heatPump, electricCar, airConditionersOneRoom, airConditionersMultipleRooms } =
    energyLandscape

  return (
    <FormControl>
      <>
        <SDCheckbox
          checked={dishwasher}
          onChange={value => updateAddressEnergyLandscape({ dishwasher: value })}
          label={t('subscriptionTools:estimator.equipment.dishwasher')}
        />

        <SDCheckbox
          checked={dryer}
          onChange={value => updateAddressEnergyLandscape({ dryer: value })}
          label={t('subscriptionTools:estimator.equipment.dryer')}
        />

        <SDCheckbox
          checked={freezer}
          onChange={value => updateAddressEnergyLandscape({ freezer: value })}
          label={t('subscriptionTools:estimator.equipment.separate_freezer')}
        />

        <SDCheckbox
          disabled={heatingEnergy !== 'elec'}
          checked={heatPump}
          onChange={value => updateAddressEnergyLandscape({ heatPump: value })}
          label={t('subscriptionTools:estimator.equipment.heat_pump')}
        />

        <SDCheckbox
          checked={electricCar}
          onChange={value => updateAddressEnergyLandscape({ electricCar: value })}
          label={t('subscriptionTools:estimator.equipment.electric_car')}
        />

        <ElectricCarDistance />

        <SDCheckbox
          checked={airConditionersOneRoom}
          onChange={value =>
            updateAddressEnergyLandscape({ airConditionersOneRoom: value, airConditionersMultipleRooms: false })
          }
          label={t('subscriptionTools:estimator.equipment.air_conditioners_one_room')}
        />

        <SDCheckbox
          checked={airConditionersMultipleRooms}
          onChange={value =>
            updateAddressEnergyLandscape({ airConditionersMultipleRooms: value, airConditionersOneRoom: false })
          }
          label={t('subscriptionTools:estimator.equipment.air_conditioners_multiple_rooms')}
        />
      </>
    </FormControl>
  )
}

export default EquipmentFields
